

















import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class SlideControl extends Vue implements Components.IControl {
  @Prop({default:null}) public editor: Components.IEditor;
  @Prop({default:null}) public slideItems:any;
  @Prop({default:true}) public enabled: boolean;
  @Prop({default:true}) public isEdit: boolean;
  public currentItem:any = null;
  public slideId:number = -1;
  public itemCount:number = 0;
  public validator: Components.ControlValidator;

  public mounted() {
    if(this.slideItems)this.itemCount = this.slideItems.length;
    if (this.editor != null) this.editor.addControl(this);
    this.slideId=0;
  }

  @Watch('slideItems')
  public onSlideItemsUpdated(){
    //コレクションのリロード時に再バインドする
    this.onslideIdChanged();
  }

  @Watch('slideId')
  public onslideIdChanged(){
    if (this.slideId == -1 || this.slideItems == null) this.currentItem = null;
    else this.currentItem = this.slideItems[this.slideId];
  }
  public moveBack(){
    if (this.slideItems && this.slideItems.length > 0 && this.slideId > 0)this.slideId--;
  }
  public moveNext(){
    if (this.slideItems && this.slideItems.length > this.slideId +1)this.slideId++;
  }
  public get canMoveNext(){
    return this.slideItems && this.slideItems.length > this.slideId +1;
  }
  public get canMoveBack(){
    return this.slideItems && this.slideItems.length > 0 && this.slideId > 0;
  }

  public isTouchStarted: boolean  = false;
  public startPosition: number = 0;
  public offset: number = 0;
  public onTouchStart(e: any){
    if (this.isTouchStarted == false){
      this.isTouchStarted = true;
      this.startPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      console.log('touch started');
    }
  }
  public onTouchMove(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      this.offset = currentPosition - this.startPosition;
      if (this.offset > 0 && this.canMoveBack == false) this.offset = 0;
      else if (this.offset < 0 && this.canMoveNext == false) this.offset = 0;
      console.log('touch moved');
    }
  }  
  public onTouchEnd(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      if (currentPosition - this.startPosition > 80 && this.canMoveBack) this.slideId -=1;
      else if (currentPosition - this.startPosition < -80 && this.canMoveNext) this.slideId +=1;
      
      this.isTouchStarted = false;
      this.offset = 0;
      console.log('touch ended {0}->{1}', this.startPosition,currentPosition);      
    }
  }
}
